import React from "react";
import { Spinner, Alert } from "react-bootstrap";

interface LoaderErrorProps {
  loading: boolean;
  error?: string | null;
  children: React.ReactNode;
}

const LoaderErrorWrapper: React.FC<LoaderErrorProps> = ({
  loading,
  error,
  children,
}) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="my-3">
        <strong>Error:</strong> {error}
      </Alert>
    );
  }

  return <>{children}</>;
};

export default LoaderErrorWrapper;
